import APIController from '../core-api-controller';

export const fetchTicketsApi = (paramsStr = '', paramsObj = {}) => {
  const path = `${APIController.endpointApi}/tickets${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const fetchTicketApi = (id = '') => {
  const path = `${APIController.endpointApi}/tickets/${id}`;
  return APIController.getApiCallback(path);
};

export const fetchTicketFollowUpsApi = (id, paramsStr = '', paramsObj = {}) => {
  const path = `${APIController.endpointApi}/tickets/${id}/follow_ups${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};
